import { defineFcm } from '../shared/factory';

export const FCM_MEMBERSHIP_PPMU_ENABLED_FOR = defineFcm('membership_ppmu_enabled_for')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'corgi-front-end',
		context: 'Post Promote Membership Upsell (PPMU)',
		description: 'This configuration determines whether PPMU is enabled for a country',
	});
